export default "__VITE_ASSET__hdfGMtA1__"